import { createProvider } from '@/vue-apollo'
import gql from 'graphql-tag'

import fetchCheckingListQuery from '@/graphql/queries/fetchCheckingList.gql'

const apolloClient = createProvider().defaultClient
const loadingStateKey = 'checking'

const state = {
  all: [],
  filters: {
    search: '',
    perPage: 100,
    page: 1
  },
  paginationInfo: {
    total: 0,
    count: 0,
    currentPage: 1,
    hasMorePages: false,
    lastPage: 1
  }
}
const actions = {
  fetchAllCheckingList: async ({ commit }, noLoadingState = false) => {
    if (!noLoadingState) {
      commit('setLoadingState', { key: loadingStateKey, isLoading: true }, { root: true })
    }

    let filters = []

    if (state.filters.search !== '') {
      filters.push({ field: 'name', keyword: state.filters.search })
    }

    const result = await apolloClient.query({
      query: fetchCheckingListQuery,
      variables: {
        count: state.filters.perPage,
        page: state.filters.page,
        sort: state.filters.sortBy,
        filters
      },
      fetchPolicy: 'no-cache'
    })
    commit('setProjectPaginationInfo', result.data.checkings.paginatorInfo)
    commit('setAllCheckingList', result.data.checkings.data)
    commit('setLoadingState', { key: loadingStateKey, isLoading: false }, { root: true })
  },
  updateChecking: async ({ commit }, payload) => {
    const result = await apolloClient.mutate({
      mutation: gql`mutation ($id: ID!, $input: CheckingUpdateInput) { updateChecking(id: $id, input: $input) { id, checkingStatus, check { no payee date amount payIn docNo } } }`,
      variables: { id: payload.projectId, input: payload.form }
    })

    commit('setNewCheck', { projectId: payload.projectId, result: result.data.updateChecking })
  }
}

const mutations = {
  setAllCheckingList: (state, checkingList) => { state.all = checkingList.filter(check => !check.funding.noOsda) },
  setNewCheck: (state, { projectId, result }) => {
    let project = state.all.find(project => project.id === projectId)
    if (typeof result.check.date === 'string') {
      result.check.date = { 'date': result.check.date }
    }
    project.check = result.check
    project.checkingStatus = result.checkingStatus
  },
  setPerPageFilter: (state, perPage) => { state.filters.perPage = perPage },
  setPageFilter: (state, page) => { state.filters.page = page },
  setSearchCheckingKeyword: (state, keyword) => {
    state.filters.search = keyword
    state.filters.page = 1
  },
  setProjectPaginationInfo: (state, paginationInfo) => { state.paginationInfo = paginationInfo }
}
const getters = {
  getCheckingById: state => projectId => state.all.find(project => project.id === projectId),
  getFilteredCheckingList (state) { return state.all.filter(project => { return project.name.indexOf(state.filters.search) > -1 }) } }

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
